import { AliasLabel } from 'features/store/pages/delivery-store-selector/types';

import { ALIAS_MARKER_MAP } from './constants';
import { MarkerTypes } from './types';

export const svgToUri = (svg: string): string => `data:image/svg+xml;base64,${btoa(svg)}`;

export const getMarkerTypeForAlias = (alias?: string): MarkerTypes => {
  if (!alias || !Object.values(AliasLabel).includes(alias as AliasLabel)) {
    return MarkerTypes.DeliveryLocation;
  }
  return ALIAS_MARKER_MAP[alias as AliasLabel];
};
